/**
 * @flow
 * @relayHash 315de46cbfc47e08b0c9af75d4587457
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type WhatIsThis_occurrence$ref = any;
export type WhatIsThisIdentifyInput = {|
  id: string,
  lifeId: string,
  clientMutationId?: ?string,
  revisionMessage?: ?string,
|};
export type WhatIsThisIdentifyMutationVariables = {|
  input: WhatIsThisIdentifyInput
|};
export type WhatIsThisIdentifyMutationResponse = {|
  +whatIsThisIdentify: ?{|
    +occurrence: ?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: WhatIsThis_occurrence$ref,
      |}
    |},
    +errors: ?$ReadOnlyArray<?{|
      +code: ?string,
      +location: ?string,
      +message: string,
    |}>,
  |}
|};
export type WhatIsThisIdentifyMutation = {|
  variables: WhatIsThisIdentifyMutationVariables,
  response: WhatIsThisIdentifyMutationResponse,
|};
*/


/*
mutation WhatIsThisIdentifyMutation(
  $input: WhatIsThisIdentifyInput!
) {
  whatIsThisIdentify(input: $input) {
    occurrence {
      node {
        id
        ...WhatIsThis_occurrence
      }
    }
    errors {
      code
      location
      message
    }
  }
}

fragment WhatIsThis_occurrence on Occurrence {
  id
  where
  when
  notes
  myPerms
  identity {
    id
    ...PlantLink_plant
  }
  images(first: 20) {
    edges {
      node {
        id
        smallImage: image(width: 860, height: 645) {
          url
        }
        ...ImageThumbnail_image
      }
    }
  }
  revisionCreated {
    createdAt
    author {
      avatar(width: 40, height: 40) {
        url
      }
      username
      ...ProfileLink_user
      id
    }
    id
  }
  ...SuggestionsList_occurrence
}

fragment PlantLink_plant on LifeNode {
  id
  idInt
  title
  slug
}

fragment ImageThumbnail_image on Image {
  id
}

fragment ProfileLink_user on User {
  id
  username
  firstName
  reputation
  avatar(width: 40, height: 40) {
    url
  }
}

fragment SuggestionsList_occurrence on Occurrence {
  id
  myPerms
  identity {
    id
    ...PlantLink_plant
  }
  suggestions(first: 100) {
    totalCount
    edgeCount
    edges {
      node {
        id
        ...SuggestionItem_suggestionID
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment SuggestionItem_suggestionID on SuggestionID {
  id
  myPerms
  notes
  author {
    avatar(width: 40, height: 40) {
      url
    }
    username
    ...ProfileLink_user
    id
  }
  identity {
    id
    rankDisplay
    description
    ...PlantLink_plant
  }
  voting {
    ...VotingButtons_voting
    id
  }
  revisionCreated {
    createdAt
    id
  }
}

fragment VotingButtons_voting on Voting {
  id
  countUps
  countDowns
  sumValues
  mine {
    id
    value
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "WhatIsThisIdentifyInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "code",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "myPerms",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "idInt",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v9 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  }
],
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "author",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "avatar",
      "storageKey": "avatar(height:40,width:40)",
      "args": [
        {
          "kind": "Literal",
          "name": "height",
          "value": 40
        },
        {
          "kind": "Literal",
          "name": "width",
          "value": 40
        }
      ],
      "concreteType": "File",
      "plural": false,
      "selections": (v9/*: any*/)
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "username",
      "args": null,
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "reputation",
      "args": null,
      "storageKey": null
    }
  ]
},
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "WhatIsThisIdentifyMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "whatIsThisIdentify",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "WhatIsThisIdentifyPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "occurrence",
            "storageKey": null,
            "args": null,
            "concreteType": "OccurrenceEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Occurrence",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "WhatIsThis_occurrence",
                    "args": null
                  }
                ]
              }
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "WhatIsThisIdentifyMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "whatIsThisIdentify",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "WhatIsThisIdentifyPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "occurrence",
            "storageKey": null,
            "args": null,
            "concreteType": "OccurrenceEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Occurrence",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "where",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "when",
                    "args": null,
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "identity",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LifeNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "images",
                    "storageKey": "images(first:20)",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 20
                      }
                    ],
                    "concreteType": "ImageConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ImageEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Image",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": "smallImage",
                                "name": "image",
                                "storageKey": "image(height:645,width:860)",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "height",
                                    "value": 645
                                  },
                                  {
                                    "kind": "Literal",
                                    "name": "width",
                                    "value": 860
                                  }
                                ],
                                "concreteType": "File",
                                "plural": false,
                                "selections": (v9/*: any*/)
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "revisionCreated",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Revision",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v2/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "suggestions",
                    "storageKey": "suggestions(first:100)",
                    "args": (v12/*: any*/),
                    "concreteType": "SuggestionIDConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalCount",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "edgeCount",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SuggestionIDEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SuggestionID",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              (v4/*: any*/),
                              (v11/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "identity",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "LifeNode",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "rankDisplay",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "description",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "voting",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Voting",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "countUps",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "countDowns",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "sumValues",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "mine",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Vote",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "value",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "revisionCreated",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Revision",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v2/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "__typename",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "cursor",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pageInfo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "endCursor",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasNextPage",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedHandle",
                    "alias": null,
                    "name": "suggestions",
                    "args": (v12/*: any*/),
                    "handle": "connection",
                    "key": "Occurrence_suggestions",
                    "filters": null
                  }
                ]
              }
            ]
          },
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "WhatIsThisIdentifyMutation",
    "id": null,
    "text": "mutation WhatIsThisIdentifyMutation(\n  $input: WhatIsThisIdentifyInput!\n) {\n  whatIsThisIdentify(input: $input) {\n    occurrence {\n      node {\n        id\n        ...WhatIsThis_occurrence\n      }\n    }\n    errors {\n      code\n      location\n      message\n    }\n  }\n}\n\nfragment WhatIsThis_occurrence on Occurrence {\n  id\n  where\n  when\n  notes\n  myPerms\n  identity {\n    id\n    ...PlantLink_plant\n  }\n  images(first: 20) {\n    edges {\n      node {\n        id\n        smallImage: image(width: 860, height: 645) {\n          url\n        }\n        ...ImageThumbnail_image\n      }\n    }\n  }\n  revisionCreated {\n    createdAt\n    author {\n      avatar(width: 40, height: 40) {\n        url\n      }\n      username\n      ...ProfileLink_user\n      id\n    }\n    id\n  }\n  ...SuggestionsList_occurrence\n}\n\nfragment PlantLink_plant on LifeNode {\n  id\n  idInt\n  title\n  slug\n}\n\nfragment ImageThumbnail_image on Image {\n  id\n}\n\nfragment ProfileLink_user on User {\n  id\n  username\n  firstName\n  reputation\n  avatar(width: 40, height: 40) {\n    url\n  }\n}\n\nfragment SuggestionsList_occurrence on Occurrence {\n  id\n  myPerms\n  identity {\n    id\n    ...PlantLink_plant\n  }\n  suggestions(first: 100) {\n    totalCount\n    edgeCount\n    edges {\n      node {\n        id\n        ...SuggestionItem_suggestionID\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment SuggestionItem_suggestionID on SuggestionID {\n  id\n  myPerms\n  notes\n  author {\n    avatar(width: 40, height: 40) {\n      url\n    }\n    username\n    ...ProfileLink_user\n    id\n  }\n  identity {\n    id\n    rankDisplay\n    description\n    ...PlantLink_plant\n  }\n  voting {\n    ...VotingButtons_voting\n    id\n  }\n  revisionCreated {\n    createdAt\n    id\n  }\n}\n\nfragment VotingButtons_voting on Voting {\n  id\n  countUps\n  countDowns\n  sumValues\n  mine {\n    id\n    value\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '483c8cee12c5b43c8c82bd0abed6d49e';
module.exports = node;
